<template>
  <page :load="doInit">
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12 md3>
          <v-navigation-drawer permanent light width="100%" class="mavSmallMenu">
              <v-toolbar flat>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title class="title">
                        {{ this.promotion }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-toolbar>
              <v-list class="pt-0">
                <v-divider></v-divider>
                <v-list-tile v-for="item in sideMenu" :key="item.name" :to="{ name: item.name }">
                  <v-list-tile-action v-if="item.name === 'promotionFactorsQuery'">
                    <v-icon :class="isMatchRoute('promotionFactorQuery') ? 'primary--text':''">{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-action v-else>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content v-if="item.name === 'promotionFactorsQuery'">
                    <v-list-tile-title :class="isMatchRoute('promotionFactorQuery') ? 'primary--text':''">{{ item.text }}</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-content v-else>
                    <v-list-tile-title >{{ item.text }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-navigation-drawer>
        </v-flex>
        <v-flex xs12 md9>
          <transition name="slide-x-transition" mode="out-in">
            <router-view ></router-view>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </page>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import routeMixin from '@/mixins/route'

export default {
  data() {
    return {
      sideMenu: [
        { name: 'promotionQuery', text: 'Promotion', icon: 'mdi-star' },
        { name: 'promotionFactorsQuery', text: 'Factor/Rates', icon: 'mdi-sale' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  methods: {
    ...mapActions([
      'promotionInit'
    ]),
    async doInit() {
      await this.promotionInit(this.promotion)
      if (this.$store.state.promotionManagement.promotion.cardPromo) {
        this.sideMenu.push({ name: 'promotionCreditCardQuery', text: 'Credit Card List', icon: 'mdi-credit-card-multiple' })
      }
      if (this.$store.state.promotionManagement.promotion.couponPromo) {
        this.sideMenu.push({ name: 'promotionCouponQuery', text: 'Coupons', icon: 'mdi-ticket-percent' })
      }
      if (this.$store.state.promotionManagement.promotion.usrGrpPromo) {
        this.sideMenu.push({ name: 'promotionMemberGroupQuery', text: 'Member Groups', icon: 'mdi-account-card-details' })
      }
    }
  },
  props: {
    promotion: {
      type: String,
      default: ''
    }
  },
  mixins: [
    routeMixin
  ]
}
</script>

<style lang="scss">
</style>
